.messageText {
  margin: 0;
  white-space: pre-wrap;
}

.card {
  margin-bottom: 2rem;
}

.answersGrid {
  align-items: center;
  display: grid;
  font-size: 2.25rem;
  gap: 3rem 1rem;
  grid-template-columns: 5fr 1fr;
}

.answerLabel {
  min-width: 0;
}

.answerDescription {
  font-size: var(--font-size-small);
  margin: 0.5rem 0 0;
}

.nonResponseText {
  margin: 0 0 1rem;
}
